import { render, staticRenderFns } from "./OwnGoodsList.vue?vue&type=template&id=5c10ce8e&scoped=true"
import script from "./OwnGoodsList.vue?vue&type=script&lang=js"
export * from "./OwnGoodsList.vue?vue&type=script&lang=js"
import style0 from "./OwnGoodsList.vue?vue&type=style&index=0&id=5c10ce8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c10ce8e",
  null
  
)

export default component.exports